import Chart from 'chart.js';
import 'chartjs-plugin-deferred';
import 'chartjs-plugin-doughnutlabel';
import 'chartjs-plugin-datalabels';

const charts = () => {
  const colors = [
    '#08183b',
    '#00485b',
    '#006766',
    '#099183',
    '#00906b',
    '#10b24b',
  ];
  const textColor = '#121212';
  const ctx1 = document.getElementById('chart-1');
  const chart1 = new Chart(ctx1, {
    type: 'doughnut',
    data: {
      labels: [ 'Floods', 'Hurricanes', 'Winter Storms', 'Fires', 'Pandemics', 'Tornados' ],
      datasets: [{
        label: '',
        data: [28, 13, 5, 2, 1, 1],
        backgroundColor: colors,
        borderColor: colors,
        borderWidth: 1,
      }],
    },
    options: {
      tooltips: {
        titleFontSize: 16,
        bodyFontSize: 16,
      },
      cutoutPercentage: 65,
      legendCallback: function(chart) {
        console.log(chart.data);
        let legendHTML = [];
        legendHTML.push('<ul class="legend-list">');
        for (let i = 0; i < chart.data.labels.length; i++) {
          legendHTML.push('<li>');
          legendHTML.push('<span class="legend-icon" style="background-color:' + chart.data.datasets[0].borderColor[i] + '"></span>');
          legendHTML.push('<span class="legend-label">' + chart.data.labels[i] + '</span>');
          legendHTML.push('</li>');
        }
        legendHTML.push('</ul>');
        return legendHTML.join("");
      },
      legend: {
        position: 'bottom',
        display: false,
        labels: {
          fontColor: textColor,
          boxWidth: 15,
          padding: 20,
          fontSize: 15,
        },
      },
      layout: {
        padding: {
          left: 0,
          right: 0,
          top: 40,
          bottom: 40,
        },
      },
      plugins: {
        deferred: {
          delay: 100,
          yOffset: 200,
        },
        doughnutlabel: {
          labels: [
            {
              text: '$2B+',
              font: {
                size: 75,
                weigth: 600,
              },
              color: textColor,
            },
          ],
        },
        datalabels: {
          formatter: function(value, context) {
            return value;
          },
          align: 'middle',
          anchor: 'middle',
          color: function(context) {
            return '#fff';
          },
          font: {
            size: 18,
            weight: 600,
          },
        },
      },
    },
  });
  document.getElementById('chart-legend-1').innerHTML = chart1.generateLegend();

  const ctx2 = document.getElementById('chart-2');
  const chart2 = new Chart(ctx2, {
    type: 'doughnut',
    data: {
      labels: ['Hazard Mitigation Plans', 'Other EM Plans', 'Recovery Plans', 'Debris Management Plans', 'Public Health Plans'],
      datasets: [{
        label: '',
        data: [51, 32, 28, 8, 7],
        backgroundColor: colors,
        borderColor: colors,
        borderWidth: 1,
      }],
    },
    options: {
      tooltips: {
        titleFontSize: 16,
        bodyFontSize: 16,
      },
      cutoutPercentage: 65,
      legendCallback: function(chart) {
        console.log(chart.data);
        let legendHTML = [];
        legendHTML.push('<ul class="legend-list">');
        for (let i = 0; i < chart.data.labels.length; i++) {
          legendHTML.push('<li>');
          legendHTML.push('<span class="legend-icon" style="background-color:' + chart.data.datasets[0].borderColor[i] + '"></span>');
          legendHTML.push('<span class="legend-label">' + chart.data.labels[i] + '</span>');
          legendHTML.push('</li>');
        }
        legendHTML.push('</ul>');
        return legendHTML.join("");
      },
      legend: {
        position: 'bottom',
        display: false,
        labels: {
          fontColor: textColor,
          boxWidth: 15,
          padding: 20,
          fontSize: 15,
        },
      },
      layout: {
        padding: {
          left: 0,
          right: 0,
          top: 40,
          bottom: 40,
        },
      },
      plugins: {
        deferred: {
          delay: 100,
          yOffset: 200,
        },
        doughnutlabel: {
          labels: [
            {
              text: '400+',
              font: {
                size: 75,
              },
              color: textColor,
            },
          ],
        },
        datalabels: {
          formatter: function(value, context) {
            return value;
          },
          align: 'middle',
          anchor: 'middle',
          color: function(context) {
            return '#fff';
          },
          font: {
            size: 18,
            weight: 600,
          },
        },
      },
    },
  });
  document.getElementById('chart-legend-2').innerHTML = chart2.generateLegend();
};

export default charts;